import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';

import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';

import { useGetPatientHealthSummaryRecords } from '@hooks/api/patient-record';

import HealthSummaryContent from './Main';

function HealthSummary() {
  const { data, loading } = useGetPatientHealthSummaryRecords({
    allergy: true,
    condition: true,
    immunization: true,
    medication_statement: true,
    procedure: true,
    legal_directives: true,
    related_person: true,
    coverage: true,
    patient: true,
    blood_type: true,
    height_body_observation: true,
    weight_body_observation: true,
    care_team: true,
  });

  return <HealthSummaryContent data={data} loading={loading} />;
}

export default withErrorBoundary(HealthSummary, {
  FallbackComponent: ErrorBoundaryFallback,
});
